import React, { lazy } from 'react'

const CheckResult = lazy(() => import('./CheckResult'))
const ActivationPage = lazy(() => import('./ActivationPage'))
const ActivationSuccessPage = lazy(() => import('./ActivationSuccessPage'))
const GuestWrapper = lazy(() => import('./components/GuestWrapper'))
const PartnerConfirmationWrapper = lazy(() => import('./components/PartnerConfirmationWrapper'))
const ManageBooking = lazy(() => import('./ManageBooking'))
const PartnerResult = lazy(() => import('./PartnerResult'))

const GuestRouting = [
  {
    element: <GuestWrapper element={<ManageBooking />} />,
    path: 'manage-booking/:patientEventUuid',
  },
  {
    element: <GuestWrapper element={<CheckResult />} />,
    path: 'check-result/:patientEventUuid',
  },
  {
    element: <PartnerConfirmationWrapper
      customPartner="teleclinic"
      element={<PartnerResult customPartner="teleclinic" />}
    />,
    path: 'teleclinic-confirmation/:orderID',
  },
  {
    element: <PartnerConfirmationWrapper element={<PartnerResult />} />,
    path: 'partner-confirmation/:orderID',
  },
  {
    element: <GuestWrapper element={<ActivationPage />} />,
    path: 'activate',
    public: true,
  },
  {
    element: <GuestWrapper element={<ActivationSuccessPage />} />,
    path: 'activate/success',
    public: true,
  },
]

export default GuestRouting
